import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, useSEO } from "@/lib/api";
import { MaskReveal, Reveal } from "@/components/Reveal";

// Preferred VYRON product image per collection tile
const COLLECTION_IMAGE = {
  "new-arrivals": "/assets/vyron/taupe-d.jpeg",
  "signature-collection": "/assets/vyron/noir-5.jpeg",
};

export default function Collections() {
  useSEO("Collections", "Explore VYRON eyewear collections — New Arrivals and the Signature Collection. Premium polarized eyewear crafted in India.");
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    api.get("/collections").then((r) => setCollections(r.data.collections)).catch(() => {});
  }, []);

  return (
    <div data-testid="collections-page" className="pt-32 pb-28">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="mb-14">
          <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">Explore</p>
          <h1 className="font-display text-5xl md:text-8xl tracking-[-0.03em] leading-[0.88]">
            <MaskReveal>Collections</MaskReveal>
          </h1>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8">
          {collections.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.08}>
              <Link to={`/collection/${c.slug}`} data-testid={`collection-tile-${c.slug}`}
                className="group relative block aspect-[4/5] rounded-3xl overflow-hidden zoom-frame bg-[#F5F5F5]">
                <img
                  src={COLLECTION_IMAGE[c.slug] || "/assets/vyron/taupe-d.jpeg"}
                  alt={`VYRON ${c.name}`}
                  loading="lazy"
                  className="w-full h-full object-contain p-8 bg-[#F5F5F5]"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 to-transparent" />
                <div className="absolute bottom-0 left-0 p-8 text-white flex items-center justify-between w-full">
                  <h3 className="font-display text-4xl tracking-tight">{c.name}</h3>
                  <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  );
}
